import { useEffect, useState } from "react";
import { Empty } from "@/admin/ui";

export default function DataTable({ columns, rows, rowKey = "id", pageSize = 20, testid, emptyText }) {
  const [page, setPage] = useState(0);
  useEffect(() => setPage(0), [rows.length]);
  const pages = Math.max(1, Math.ceil(rows.length / pageSize));
  const slice = rows.slice(page * pageSize, (page + 1) * pageSize);
  return (
    <div data-testid={testid}>
      <div className="adm-table-wrap">
        <table className="adm-table">
          <thead><tr>{columns.map((c) => <th key={c.key} className={c.num ? "num" : ""}>{c.label}</th>)}</tr></thead>
          <tbody>
            {slice.map((r) => (
              <tr key={r[rowKey]} data-testid={`${testid}-row-${r[rowKey]}`}>
                {columns.map((c) => <td key={c.key} className={c.num ? "num" : ""}>{c.render ? c.render(r) : r[c.key]}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
        {!rows.length && <Empty text={emptyText} testid={`${testid}-empty`} />}
      </div>
      {pages > 1 && (
        <div className="adm-row" style={{ justifyContent: "flex-end", marginTop: ".75rem" }}>
          <span className="adm-sub">Página {page + 1} de {pages}</span>
          <button className="adm-btn sm" disabled={page === 0} onClick={() => setPage(page - 1)} data-testid={`${testid}-prev`}>Anterior</button>
          <button className="adm-btn sm" disabled={page >= pages - 1} onClick={() => setPage(page + 1)} data-testid={`${testid}-next`}>Siguiente</button>
        </div>
      )}
    </div>
  );
}
